<template>
  <el-card
    class="moving-guide-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="moving-guide-card__body">
      <div>
        <font-awesome-icon
          :icon="['fal', 'file-alt']"
          size="2x"
          class="descriptifs__cards__icon"
        />
      </div>
      <h3 class="moving-guide-card__body__h3 center-v-h">
        {{ $t('home.descriptifsCards.guide') }}
      </h3>
      <p class="moving-guide-card__body__text to-upper-case center-v-h">
        {{ $t('home.descriptifsCards.simpleMove') }}
      </p>
      <div class="moving-guide-card__body__button">
        <a :href="zenbookUrl" target="_blank">
          <el-button
            type="primary">
            {{ $t('home.descriptifsCards.download') }}
          </el-button>
        </a>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'pinia';
import { useProjectStore } from '@/stores';

export default {
  name: 'movingGuideCard',
  computed: {
    ...mapState(useProjectStore, ['projectSelected']),
    isCommissionnaire() {
      return this.projectSelected && this.projectSelected.params.is_commissionaire;
    },
    isIndividual() {
      return this.projectSelected && this.projectSelected.params.is_individual;
    },
    isMinarm() {
      return this.projectSelected && this.projectSelected.params.is_minarm;
    },
    zenbookUrl() {
      if (this.isCommissionnaire && !this.isMinarm) {
        if (this.isIndividual) {
          return `${import.meta.env.VITE_APP_PUBLIC_ASSETS_URL}Zenbook_Nextories_CGP.pdf`;
        }
        return `${import.meta.env.VITE_APP_PUBLIC_ASSETS_URL}Zenbook_Nextories_CGC.pdf`;
      }
      return `${import.meta.env.VITE_APP_PUBLIC_ASSETS_URL}Zenbook_Nextories.pdf`;
    },
  },
};
</script>

<style scoped lang="scss">
.moving-guide-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__h3 {
      margin-top: 10px;
      margin-bottom: 0;
      height: 60px;
    }
    &__text {
      margin: 10px 0;
      font-size: 16px;
      flex: 1 1;
    }
  }
}
</style>
